import { gql } from '@apollo/client'
export const queryOpenAPIDeveloperList = gql`
query OpenAPIDeveloperList($page: Int!, $count: Int!, $email: String) {
  openAPIDeveloperList(page: $page, count: $count, email: $email) {
    data {
      appUserId
      client
      createTime
      lastChangeTime
      organization
    }
    total
  }
}
`
export const queryOpenAPIDeveloperBindUserByDate = gql`
query OpenAPIDeveloperBindUserByDate($appUserId: Int!, $startDate: Date!, $endDate: Date!) {
  openAPIDeveloperBindUserByDate(appUserId: $appUserId, startDate: $startDate, endDate: $endDate) {
    month
    count
  }
}
`
export const queryOpenAPIDeveloperSoultionsByMonths = gql`
query OpenAPIDeveloperSoultionsByMonths($appUserId: Int!, $year: Int!, $months: [Int]!) {
  openAPIDeveloperSoultionsByMonths(appUserId: $appUserId, year: $year, months: $months) {
    pull {
      month
      count
    }
    push {
      month
      count
    }
    pubsub {
      month
      count
    }
  }
}
`
export const OpenAPIDeveloperAppList=gql`
query OpenAPIDeveloperAppList($appUserId: Int!, $page: Int!, $count: Int!) {
  openAPIDeveloperAppList(appUserId: $appUserId, page: $page, count: $count) {
    data {
      appName
      clientId
      expiredTime
      lastChangeTime
      solutions
    }
    total
  }
}
`